import { FormattedMessage as FM } from "react-intl";

import Dialog from "componentsv2/modal/Dialog";
import StepForm from "componentsv2/step/StepForm";
import { useWizard } from "storev2/wizardStore";
import { cn } from "tools/ui";
import { SIZES } from "./constants";

const base =
  "flex mx-auto shadow-md py-2 px-3 border rounded-lg hover:bg-neutral-300 active:scale-95 cursor-pointer items-center";

function ButtonAction({
  wizard,
  openModal,
  size,
  styleBtn,
  onClose,
  icon,
  stepSignals,
}) {
  const { views, name, recordId } = wizard;
  console.log("wizard data...", wizard);
  const { nextMsg, nextWidget, nextButtons } = stepSignals;
  const { store, reset, updateWizard } = useWizard();
  const bgColor = "bg-white";

  function onCloseModal() {
    openModal.value = false;
    reset();
    if (onClose) {
      onClose();
    }
  }

  async function onClick(e) {
    e.preventDefault();
    e.stopPropagation();
    nextWidget.value = null;
    // Here it clean up the store
    setStep("start");
    openModal.value = true;
  }

  function setStep(next, msgError) {
    const { Component, msg, buttons, initialStore } = views[next];
    if (msgError) {
      nextMsg.value = msgError;
    } else if (msg) {
      nextMsg.value = <FM id={msg} key={msg} />;
    }
    if (initialStore) {
      let _initialStore = initialStore;
      if (typeof initialStore === "function") {
        _initialStore = initialStore();
      }
      updateWizard(_initialStore);
    }
    nextWidget.value = Component ? (
      <Component store={store} defaults={initialStore} />
    ) : null;

    if (buttons) {
      for (const btn of buttons) {
        btn.onClick = handleButton;
      }
    }
    nextButtons.value = buttons;
  }

  async function handleButton(btn) {
    const data = store ? store : {};
    if (recordId) {
      data.recordId = recordId;
    }
    const { next, msgError } = await btn.handleClick(data);
    setStep(next, msgError);
  }

  const _size = size || "base";
  const sizeBtn = SIZES[_size].button;
  const sizeText = SIZES[_size].text;

  return (
    <div key={name}>
      <div onClick={onClick} className={cn(base, bgColor, sizeBtn, styleBtn)}>
        {icon}
        <div className="flex md:text-xs 2xl:text-base ml-3 items-center h-5!">
          <span className={cn("my-auto ml-auto text-center", sizeText)}>
            <FM id={name} />
          </span>
        </div>
      </div>
      <Dialog
        title={name}
        openModal={openModal}
        handleClose={onCloseModal}
        size="h-fit min-w-1/2"
        buttons={nextButtons.value}
      >
        <StepForm
          key={name}
          name={name}
          nextWidget={nextWidget}
          nextMsg={nextMsg}
        />
      </Dialog>
    </div>
  );
}

export default ButtonAction;
